// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2":"228aa9d5","72":"9305e070","690":"a7558cbc"}[chunkId] + ".chunk.css");